import TextField from "../../../components/fields/textField/TextField.vue";
import SelectField from "../../../components/fields/selectField/SelectField.vue";
import PeriodoField from "../../../components/fields/periodoField/PeriodoField.vue";
import TextAreaField from "../../../components/fields/textAreaField/TextAreaField.vue";
import FileInputField from "../../../components/fields/file-input-field/FileInputField.vue";
import { SnackBarModule } from "../../../modules/SnackBarModule";
import moment from "moment";
import { TiposFeriasEnum} from "../../../constants";
import { AjustarFeriasService } from "../../../services/AjustarFeriasService";
import { SolicitarFeriasService } from "../../../services/SolicitarFeriasService";
import { FeriasService } from "../../../services/FeriasService";
import { calcularDiasCorridos } from "../../../helper/helper.js";



export default {
  name: "AjustarFerias",

  props: {
    selected: {
      required: true,
      default: [],
    },
    isOpen: {
      type: Boolean,
      required: true,
    }
  },

  components: {
    TextField,
    SelectField,
    PeriodoField,
    TextAreaField,
    FileInputField
  },

  computed:{
    tiposFeriasEnum(){
      return TiposFeriasEnum;
    }
  },




  data: () => ({
    id: null,

    idJustificativa:0,

    limiteDias: 25,
    numeroDiasTitulo: 'Número de dias úteis solicitados',
    titulo: 'Ajustar Férias',

    exerciciosOptions: [],
    exercicios: [],


    justificativa: "",
    form: {
      exercicio: "",
    },
   

    loading: {
      field: false,
      btn: false,
    }
  }),
  created() {
    this.getExercicioItems();
  },
  mounted(){
    this.inicializarModal();
  },

  watch: {
    isOpen: function (isOpen) {
      if (isOpen) {
        this.inicializarModal();
      }
    },
  },

  methods: {
    
    inicializarModal(){
      this.initializeForm();
      if(this.selected.idTipo == TiposFeriasEnum['FERIAS_PREMIO']){
        this.limiteDias = this.selected.numeroDias
        this.titulo = 'Ajustar Férias Prêmios'
        this.numeroDiasTitulo = 'Número de dias corridos solicitados';
      }else{
        this.limiteDias = this.selected.diasRestantes
        this.titulo = 'Ajustar Férias'
        this.numeroDiasTitulo = 'Número de dias úteis solicitados';
      }

      this.getJustificativa(this.selected.idFerias);
      this.pegarDiasRestantesDaParecela()
    },

    async pegarDiasRestantesDaParecela() {
      this.form.subtitulo = `Você possui um saldo de ${this.selected.diasRestantes} dia(s) no exercício ${this.selected.exercicio}`
    },

    async getExerciciosFeriasPremioItems() {
      this.loading.field = true;
      this.exercicios = await FeriasService.getExerciciosFeriasPremio();
      this.loading.field = false;
    },

    async getExercicioFeriasItems() {
      this.loading.field = true;
      const postData = new FormData();
      postData.append('id_tipo', this.selected.idTipo)
      const response = await FeriasService.getExercicio(postData);
      this.exerciciosOptions = response.map(el => {
        return {
          text: el.ano,
          value: el.ano,
        }
      });
      this.exerciciosOptions?.unshift({ text: "Selecione", value: "" })
      this.loading.field = false;
    },

    async getExercicioItems() {

      if(this.selected.idTipo == TiposFeriasEnum['FERIAS_PREMIO']){
        return this.exercicios = [this.selected.exercicio];
      }

      this.exerciciosOptions = [{
        text: this.selected.exercicio,
        value: this.selected.exercicio
        
      }];


    },

    async getJustificativa(id) {
      this.loading.field = true;
      const response = await AjustarFeriasService.getById(id);
      this.justificativa = response.justificativa;
      this.form.exercicio = response.exercicio;
      this.idJustificativa = response.id
      this.loading.field = false;
    },

    async calculateDays() {
  
      if (this.form.dataInicio) {
        if(this.selected.idTipo != TiposFeriasEnum['FERIAS_PREMIO']){

        const formData = new FormData();
        formData.append("data_ini", moment(this.form.dataInicio).format("YYYY-MM-DD"));
        formData.append("dias",this.form.numeroDias);
        const response =  await SolicitarFeriasService.calcularDiasUteis(formData);
        this.form.dataFim = response.dataFim;
        this.form.numeroDias = response.dias_uteis;
        return;
        } 
        this.form.dataFim = calcularDiasCorridos(this.form.dataInicio, this.form.numeroDias)
        return;

      }
      return SnackBarModule("Prencha o campo de data inicial", "error");
    },


    initializeForm() {
      this.form = {
        subtitulo: "Por favor selecione uma parcela",
        exercicio: "",
        dataInicio: null,
        dataFim: null,
        numeroDias: null,
      }
    },

    prepareForm() {
      if (this.$refs.form.validate()) {
        const formData = new FormData();
        formData.append("exercicio", this.form.exercicio);
        formData.append("data_ini", this.form.dataInicio);
        formData.append("data_fin", this.form.dataFim);
        formData.append("dias", this.form.numeroDias);
        formData.append("id_ferias", this.selected.idFerias);
        formData.append("id_recusa_justificativa", this.idJustificativa);
        formData.append("justificativa", this.justificativa);
        formData.append('id_tipo', this.selected.idTipo)

        this.saveForm(formData);
        return;
      }
      SnackBarModule("Campo(s) obrigatório(s) não informado(s).", "error");
    },

    async saveForm(formData) {
      this.loading.btn = true;
      const response = await AjustarFeriasService.ajustarFerias(formData);
      this.loading.btn = false;
      if (response) {
        this.close();
      }
    },

    close() {
      this.$refs.form.reset();
      this.$emit("on-close");
    },
  },
};